import { Button } from "antd";
import React from "react";

const AdnButton = ({ handleClick, buttonType, text, visible, style }) => {
  return (
    <Button
      style={style}
      onClick={handleClick}
      type={buttonType}
      visible={visible}
    >
      {text}
    </Button>
  );
};

export default AdnButton;
